<script>
    import Vue from "vue";

    export default {
        name: "PriceHistoryMixin",
        data() {
            return {
                price_history: [],
                loading_price_history: []
            }
        },
        methods: {

            getPriceHistory: function (game_id, callback) {
                var _this = this;

                Vue.set(_this.loading_price_history, game_id, true);

                setTimeout(() => {
                    var d = new Date();
                    d.setMonth(d.getMonth() - 6);
                    var from = d / 1000 | 0;

                    var months = _this.getMonthsIndex();

                    var request_htp = new XMLHttpRequest(); 
                    request_htp.onreadystatechange = function() {
                        if (request_htp.readyState === 4 && request_htp.status == 200) {
                            var logs = JSON.parse(request_htp.responseText).result;
                            logs = _this.addMonthIndexToLogs(logs, months);
                            var feeds = _this.separateLogsInFeeds(logs);
                            feeds = _this.addMissingMonthsToFeeds(feeds);
                            var types = _this.mergeFeedsInTypes(feeds);
                            types = _this.separateMonthsInTypes(types);
                            var timelines = _this.createMinimumPriceTimelines(types);

                            if(typeof callback != 'undefined') {
                                callback(timelines);
                            }
                            Vue.set(_this.loading_price_history, game_id, null);
                        }
                    }
                    request_htp.open('GET', 'https://www.howtoplay.ro/api/get-history-bgg-id?bggId='+game_id+'&from='+from, true);
                    request_htp.send();
                }, 0);

            },

            createMinimumPriceTimelines: function (types) {
                var timelines = {'shops': [], 'geekmarket': [], 'dinraft': []};
                Object.keys(types).forEach(function(key, index) { 

                    this[key].forEach(function(month_logs, month_index) {
                        if(month_index != 0) {
                            //skip first month
                            var logs = month_logs.sort((a,b) => 
                                (parseInt(a.stock_id) > parseInt(b.stock_id)) ? -1 : ((parseInt(b.stock_id) > parseInt(a.stock_id)) ? 1 : 
                                    (parseInt(a.min) > parseInt(b.min) ? 1 : (parseInt(b.min) > parseInt(a.min) ? -1 : 0))
                                )
                            );

                            //timelines[key][month_index] = logs;
                            timelines[key].push(logs[0]);

                        }
                    });

                }, types);

                return timelines;
                                
            },

            separateMonthsInTypes: function (types) {
                Object.keys(types).forEach(function(key, index) { 
                    var type = [];
                    this[key].forEach(function(log) {
                        if(typeof type[log.month] == 'undefined') {
                            type[log.month] = [];
                        }
                        type[log.month].push(log);
                    });
                    this[key] = type; 
                }, types);
                return types;
            },

            mergeFeedsInTypes: function (feeds) {
                var types = {'shops': [], 'geekmarket': [], 'dinraft': []};

                Object.keys(feeds).forEach(function(key, index) { 
                    this[key].forEach(function(log) {
                        switch(log.feed_type) {
                            case "41": types.geekmarket.push(log); break;
                            case "42": types.dinraft.push(log); break;
                            default: types.shops.push(log); break;
                        }
                    });
                }, feeds);

                types.shops.sort((a,b) => (parseInt(a.created) > parseInt(b.created)) ? 1 : ((parseInt(b.created) > parseInt(a.created)) ? -1 : 0));
                types.geekmarket.sort((a,b) => (parseInt(a.created) > parseInt(b.created)) ? 1 : ((parseInt(b.created) > parseInt(a.created)) ? -1 : 0));
                types.dinraft.sort((a,b) => (parseInt(a.created) > parseInt(b.created)) ? 1 : ((parseInt(b.created) > parseInt(a.created)) ? -1 : 0));

                return types;
            },

            addMissingMonthsToFeeds: function (feeds) {
                var _this = this;
                Object.keys(feeds).forEach(function(key, index) {
                    var previous_log = { ...this[key][0]};
                    var new_feed = [];
                    var month_names = _this.getMonthsNames();
                    this[key].forEach(function(log) {
                        if(log.month>previous_log.month+1) {
                            //skipped at least a month, add previous price for each skipped month
                            var previous_month = previous_log.month;
                            for(var i = previous_month; i<log.month-1; i++) {
                                previous_log.month++;
                                var d = new Date(parseInt(previous_log.created) * 1000);
                                d.setMonth(d.getMonth() + 1);
                                previous_log.created = d / 1000 | 0;
                                previous_log.date_created = d.toUTCString(); 
                                previous_log.month_name = month_names[previous_log.month-1];  
                                previous_log.generated = true;
                                new_feed.push({...previous_log});
                            }
                        }
                        if(log.month==previous_log.month+1) {
                            //next month... add previous price before price change
                            var d = new Date((parseInt(log.created)-1) * 1000); //one second before
                            previous_log.created = d / 1000 | 0;
                            previous_log.date_created = d.toUTCString(); 
                            previous_log.month = log.month;
                            previous_log.month_name = month_names[previous_log.month-1];  
                            previous_log.generated = true;
                            new_feed.push(previous_log);
                        }

                        //add current log
                        new_feed.push(log);
                        previous_log = {...log};
                    });

                    var last_entry = {...new_feed[new_feed.length - 1]};
                    var last_entry_month = last_entry.month;
                    for(var i=last_entry_month+1;i<=6;i++) {
                        //add missing months to present date
                        last_entry.month++;
                        var d = new Date(parseInt(last_entry.created) * 1000);
                        d.setMonth(d.getMonth() + 1);
                        last_entry.created = d / 1000 | 0;
                        last_entry.date_created = d.toUTCString(); 
                        last_entry.month_name = month_names[last_entry.month-1];  
                        last_entry.generated = true;

                        new_feed.push(last_entry);
                        last_entry = {...new_feed[new_feed.length - 1]};
                    }

                    this[key] = new_feed;    
                }, feeds);
                return feeds;
            },

            getMonthsIndex: function () {
                var d = new Date();
                var months = [];
                var month = d.getMonth()+1;
                months[month] = 6;
                for(var i = 5;i>=0;i--) {
                    d.setMonth(d.getMonth() - 1);
                    var month = d.getMonth()+1;
                    months[month] = i;
                }
                return months;
            },

            getMonthsNames: function () {
                var months = [];
                const formatter = new Intl.DateTimeFormat('ro', { month: 'short' });
                for(var i = 5;i>=0;i--) {
                    var d = new Date();
                    d.setMonth(d.getMonth() - i);
                    months.push(formatter.format(d));
                }
                return months;
            },

            addMonthIndexToLogs: function (logs, months) {
                var _this = this;
                var month_names = _this.getMonthsNames();
                logs.forEach(function(log, i) {
                    var d = new Date(parseInt(log.created) * 1000);
                    var month = d.getMonth()+1;
                    logs[i].month = months[month]; 
                    logs[i].month_name = month_names[logs[i].month-1];  
                    logs[i].date_created = d.toUTCString();  
                    logs[i].min = parseFloat(logs[i].min);
                });
                return logs;
            },

            separateLogsInFeeds: function (logs) {
                var feeds = [];
                logs.forEach(function(log, i) {
                    if(typeof feeds[log.shop_name+'-'+log.product_id] == 'undefined') {
                        feeds[log.shop_name+'-'+log.product_id] = [];
                    }
                    feeds[log.shop_name+'-'+log.product_id].push(log);   
                });
                return feeds;
            }

        },
        computed: {
            
        },
    };
</script>
